import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, InputLabel, List, ListItem, MenuItem, Popover, Select, Slide, Stack, Tab, Tabs, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiEndpoints, appConfigs, appRoutes } from "../../constants/ApplicationConstants";
import { getRequest, postRequest } from "../../utils/ApiUtil";
import { setPageMessage, setProcessing, setTableAttributes } from "../../store/ApplicationStore";
import { UserListSerializer, UserSerializer } from "../../serializers/UserSerializer";
import { editAdminUserInStore, storeNewUsers, storeUsers } from "../../store/AdminUsersStore";
import { MoreVert, Person, PersonOutline, Refresh, Settings, VerifiedUser, PersonOff } from "@mui/icons-material";
import { DataGrid } from '@mui/x-data-grid';
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import { RbacSerializer } from "../../serializers/RbacSerializer";
import { storeGroups } from "../../store/AdminRBACStore";
import { useHandleError } from "../others/ErrorScreen";
import revokeIcon from '../../assets/images/revoke-group-access.svg'
import accessIcon from '../../assets/images/edit-access-group.svg'
import { useNavigate } from "react-router-dom";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export default function UserManagementScreen(){
    const { users, newusers } = useSelector(state => state.adminusers);
    const { user }= useSelector(state => state.user)
    const { groups } = useSelector(state => state.adminrbac);

    const [ activeTab, setActiveTab ] = useState(0);
    const { tableAttributes } = useSelector( state => state.app);
    const [ selectedRecord, setSelectedRecord ] = useState(null);
    const [ showAdminPop, setAdminPop ] = useState(false);
    const [ showGroupPop, setGroupPop ] = useState(false);
    const [ group, setGroup ] = useState("");
    const [ showGroupRevokePop, setShowGroupRevokePop ] = useState(false);
    const [ showUserDeactivatePop, setShowUserDeactivatePop ] = useState(false);
    const [ showUserActivatePop, setShowUserActivatePop ] = useState(false);

    const [ showApprovalPop, setShowApprovalPop ] = useState(false);
    const [ showRejectionPop, setShowRejectionPop ] = useState(false);


    const dispatch= useDispatch();
    const handleError=useHandleError()
    const navigate = useNavigate();

    const fetchUsersList = useCallback(async (params)=> {
        try{
            dispatch(setProcessing(true));
            const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.getUsers, { ...tableAttributes, ...params, new: false });
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                dispatch(setTableAttributes({ ...tableAttributes, ...params}))
                dispatch(storeUsers(UserListSerializer(response.data)));
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }    
    }, [dispatch,handleError,tableAttributes]);
    const fetchNewUsersList = useCallback(async (params)=> {
        try{
            dispatch(setProcessing(true));
            const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.getUsers, { ...tableAttributes, ...params, new: true });
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                dispatch(setTableAttributes({ ...tableAttributes, ...params}))
                dispatch(storeNewUsers(UserListSerializer(response.data)));
                // if(response.data&&response.data.content&&response.data.content.length>0){
                //     setActiveTab(1);
                // }
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false))
            }
        }catch(err){
            handleError(err)
        }    
    }, [dispatch,handleError,tableAttributes]);


    useEffect(()=>{
        const fetchRbacGroups=async ()=>{
            try{
                dispatch(setProcessing(true));
                const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.getRbacGroups);
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
                    const fetchedGroups= response.data&&response.data.map((group)=>{
                        return RbacSerializer(group)
                    }).filter(obj=>obj)
                    dispatch(storeGroups(fetchedGroups));
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    dispatch(setProcessing(false))
                }
            }catch(err){
                dispatch(setProcessing(false));
                navigate(appRoutes.errorRoute); }
            }

        const fetchInitialUsersList=async (params)=>{
            try{
                dispatch(setProcessing(true));
                const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.getUsers, { ...params, new: false });
                if(response.isError){
                    dispatch(setProcessing(false));
                    dispatch(setPageMessage({message: response.message, type: "error"}));
                }else{
              
                    dispatch(storeUsers(UserListSerializer(response.data)));
                    dispatch(setPageMessage({message: response.message, type: "success"}));
                    dispatch(setProcessing(false))
                }
            }catch(err){
                dispatch(setProcessing(false));
                navigate(appRoutes.errorRoute);
            }  
        }
 
            dispatch(setTableAttributes({...appConfigs.tableAttributes,column: "last_login_time"})) 
            fetchInitialUsersList({...appConfigs.tableAttributes,column: "last_login_time"});       
            fetchRbacGroups();
     
        },[dispatch,navigate]);

    function handleAdminEditToggle(user){
        if(showAdminPop){
            setAdminPop(false); setSelectedRecord(null);
        }else{
            setAdminPop(true); setSelectedRecord(user);
        }
    }

    function handleTabChange(event, newValue){
        setActiveTab(newValue);
        dispatch(setTableAttributes(appConfigs.tableAttributes))
        if(newValue===0){
            fetchUsersList({ ...tableAttributes, column: "last_login_time"});
        }else{
            fetchNewUsersList({ ...tableAttributes, column: "last_login_time"});
        }
    }

    async function handleAdminEditSubmit(){
        try{
            dispatch(setProcessing(true));
            const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.toggleUserAdmin, selectedRecord&&selectedRecord.role_id===1?{user_id: selectedRecord.id, role_id:2}:{user_id: selectedRecord.id, role_id:1});
            if(response.isError){
                dispatch(setPageMessage({message: response.message, type: "error"}));
                setAdminPop(false); setSelectedRecord(null);
                dispatch(setProcessing(false));
            }else{
                dispatch(editAdminUserInStore(UserSerializer(response.data)));
                dispatch(setPageMessage({message: response.message, type: "success"}));
                setAdminPop(false); setSelectedRecord(null);
                dispatch(setProcessing(false));
            }
        }catch(err){
            handleError(err)
        }     
    }
    function handleGroupEditToggle(user){
        if(showGroupPop){
            setGroupPop(false); setSelectedRecord(null); setGroup(null); 
        }else{
            setGroupPop(true); setSelectedRecord(user); setGroup(user&&user.group_id)
        }
    }
    async function handleGroupEditSubmit(revoke){
        try{
            dispatch(setProcessing(true));
            const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.toggleUserGroup, revoke? {user_id: selectedRecord.id, group_id: null}:{user_id: selectedRecord.id, group_id: group});
            if(response.isError){
                dispatch(setPageMessage({message: response.message, type: "error"}));
                setGroupPop(false); setSelectedRecord(null); setGroup(null);  setShowGroupRevokePop(false);
                dispatch(setProcessing(false));
            }else{
                dispatch(editAdminUserInStore(UserSerializer(response.data)));
                dispatch(setPageMessage({message: response.message, type: "success"}));
                setGroupPop(false); setSelectedRecord(null); setGroup(null);  setShowGroupRevokePop(false);
                dispatch(setProcessing(false));
            }
        }catch(err){
            handleError(err)
        }   
    }
    function handleGroupRevokeToggle(user){
        if(showGroupRevokePop){
            setShowGroupRevokePop(false); setSelectedRecord(null);
        }else{
            setShowGroupRevokePop(true); setSelectedRecord(user);
        }
    }

    async function handleApprovalSubmit(){
        try{
            dispatch(setProcessing(true));
            const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.toggleUserGroup, {user_id: selectedRecord.id, group_id: group&&group!==""&&group});
            if(response.isError){
                dispatch(setPageMessage({message: response.message, type: "error"}));
                setShowApprovalPop(false); setSelectedRecord(null); setGroup(null);
                dispatch(setProcessing(false));
            }else{
                setShowApprovalPop(false);
                dispatch(setTableAttributes(appConfigs.tableAttributes))
                if(activeTab===1){
                    fetchNewUsersList({ ...tableAttributes, column: "last_login_time"});
                }else{
                    fetchUsersList({ ...tableAttributes, column: "last_login_time"});
                }
                dispatch(setPageMessage({message: response.message, type: "success"}));
                setShowApprovalPop(false); setSelectedRecord(null); setGroup(null);
                dispatch(setProcessing(false));
            }
        }catch(err){
            handleError(err)
        }      
    }
    async function handleRejectSubmit(){
        try{
            dispatch(setProcessing(true));
            const response = await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.toggleUserGroup, {user_id: selectedRecord && selectedRecord.id});
            if(response.isError){
                dispatch(setPageMessage({message: response.message, type: "error"}));
                setShowRejectionPop(false); setSelectedRecord(null); setGroup(null);
                dispatch(setProcessing(false));
            }else{
                dispatch(setTableAttributes(appConfigs.tableAttributes));
                setShowRejectionPop(false);
                if(activeTab===1){
                    fetchNewUsersList({ ...tableAttributes, column: "last_login_time"});
                }else{
                    fetchUsersList({ ...tableAttributes, column: "last_login_time"});
                }
                dispatch(setPageMessage({message: response.message, type: "success"}));
                setShowRejectionPop(false); setSelectedRecord(null); setGroup(null);
                dispatch(setProcessing(false));
            }
        }catch(err){
            handleError(err)
        }     
    }

    function handleUserDeactivationToggle(user){
        if(showUserDeactivatePop){
            setShowUserDeactivatePop(false); setSelectedRecord(null);  
        }else{
            setShowUserDeactivatePop(true); setSelectedRecord(user); 
        }
    }

    async function handleUserDeactivationSubmit(){
        try{
            dispatch(setProcessing(true));
            const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.deactivateUser+"/"+selectedRecord.id);
            if(response.isError){
                dispatch(setPageMessage({message: response.message, type: "error"}));
                setShowUserDeactivatePop(false); setSelectedRecord(null); 
                dispatch(setProcessing(false));
            }else{
                dispatch(editAdminUserInStore(UserSerializer(response.data)));
                setShowUserDeactivatePop(false); setSelectedRecord(null);
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false));
            }
        }catch(err){
            handleError(err)
        }     
    }
    function handleUserActivationToggle(user){
        if(showUserDeactivatePop){
            setShowUserActivatePop(false); setSelectedRecord(null);  
        }else{
            setShowUserActivatePop(true); setSelectedRecord(user); 
        }
    }

    async function handleUserActivationSubmit(){
        try{
            dispatch(setProcessing(true));
            const response = await getRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.activateUser+"/"+selectedRecord.id);
            if(response.isError){
                dispatch(setPageMessage({message: response.message, type: "error"}));
                setShowUserActivatePop(false); setSelectedRecord(null); 
                dispatch(setProcessing(false));
            }else{
                dispatch(editAdminUserInStore(UserSerializer(response.data)));
                setShowUserActivatePop(false); setSelectedRecord(null);
                dispatch(setPageMessage({message: response.message, type: "success"}));
                dispatch(setProcessing(false));
            }
        }catch(err){
            handleError(err)
        }     
    }

    return(
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box>
                        <Box display='flex' >
                            <Settings sx={{marginRight: '1rem',marginTop:'0.2rem'}}/>
                            <Stack direction='row' alignItems='center'>
                            <Box>
                                <Typography variant='h5'>User Manager</Typography>
                                <Typography sx={{opacity: '0.6'}} variant='subtitle2'>Manage user Access groups and Admin Access.</Typography>
                            </Box>
                            <Refresh onClick={()=>{fetchUsersList({ ...tableAttributes, column: "last_login_time"})}} sx={{marginLeft: '1rem', opacity: 0.6, cursor:'pointer'}} />
                            </Stack>
                        </Box>
                    </Box>
                    <Box>
                        <Tabs  sx={{
                                minHeight: '30px',
                                marginTop:'0.5rem',
                                height: '30px',
                                '& .MuiTab-root': {
                                minHeight: '30px',
                                height: '30px',
                                padding: '0px 12px',
                                textTransform: 'capitalize',
                                '&:hover': {
                                    textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)',
                                },
                                transition: 'text-shadow 0.3s ease',
                                '& .MuiTab-labelIcon': {
                                    minHeight: '30px',
                                },
                                },
                                '& .MuiTabs-indicator': {
                                bottom: '0px',
                                },
                            }}  value={activeTab} textColor="primary" indicatorColor="primary" onChange={(event, newValue) => {handleTabChange(event, newValue)}}>
                            <Tab icon={<Person />} iconPosition="start" sx={{textTransform: 'capitalize'}} label="Users" />
                            <Tab icon={<PersonOutline />} iconPosition="start" sx={{textTransform: 'capitalize'}} label={
                                <Box display='flex'>
                                    <Typography>New Access Requests</Typography>
                                    {newusers && newusers.records.length >0 && <Typography color='white.main' sx={{marginLeft: '1rem', backgroundColor: 'red',width:'1.5rem',height:'1.5rem', borderRadius: '50%'}}>{newusers.total_elements}</Typography>}
                                </Box>
                            } />
                        </Tabs>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    {newusers && activeTab === 1 && <DataGrid disableRowSelectionOnClick autoHeight
                        sx={{
                            '& .MuiDataGrid-columnHeaders': {
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontWeight: 'bold',
                                },
                            }
                        }}
                        slotProps={{
                            filterPanel: {
                                filterFormProps:{
                                    operatorInputProps:{
                                        sx:{
                                            display: 'none'
                                        }
                                    }
                                }
                            }
                        }}
                        rows={newusers.records}
                        columns={[
                            { field: 'username',  hideable: false, headerName: 'Username', width: 200},
                            { field: 'fullname', headerName: 'Full Name', width: 200},
                            { field: 'email', headerName: 'Email', width: 220},
                            { field: 'group_id', headerName: 'Group', width: 190, filterable: false, disableColumnMenu: true, sortable: false, renderCell: (params) => (
                                <Box mt={2}>
                                    {groups&&groups.length>0?
                                    <FormControl fullWidth  size='small' >
                                        <InputLabel >Assign Access Group</InputLabel>
                                        <Select  sx={{height:'33px'}}  value={selectedRecord&&selectedRecord.id===params.row.id?group:""}  label="Assign Access Group" onChange={(e)=>{setSelectedRecord(params.row); setGroup(e.target.value)}}>
                                            <MenuItem value="">Select</MenuItem>
                                            {groups&&groups.map((item)=>{
                                                return <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                    :<Typography>No groups configured at present.</Typography>}

                                </Box>
                            ) },
                            { field: 'customField', headerName: 'Actions', width: 200, filterable: false, renderCell: (params) => (
                                <Stack mt={2} direction='row' spacing={2}>
                                    <Button sx={{ textTransform: 'capitalize' }} onClick={()=>{setShowRejectionPop(true) ;setSelectedRecord(params.row)}} color="primary" variant='outlined'>Reject</Button>
                                    {groups&&groups.length>0&& <Button disabled={!(selectedRecord&&selectedRecord.id===params.row.id&&group&&group!=="")} sx={{ textTransform: 'capitalize' }} onClick={()=>{setShowApprovalPop(true)}} color="primary" variant='contained'>Approve</Button>}
                                </Stack>
                            ) },
                        ]}
                        pagination
                        initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: appConfigs.tableAttributes.size,
                                page: 0,
                              },
                            }
                        }}
                        getRowHeight={() => 70}
                        pageSizeOptions={appConfigs.tablePageOptions}
                        paginationMode='server'
                        sortingMode="server"
                        onSortModelChange={(param)=>fetchNewUsersList(param[0]?{column:param[0].field, order: param[0].sort}:{column: "last_login_time"})}
                        rowCount={newusers.total_elements}
                        onPageChange={(param)=>fetchNewUsersList({column:param[0].field, order: param[0].sort})}
                        onPaginationModelChange={(param)=>fetchNewUsersList({page: param.page+1, size:param.pageSize, column: "last_login_time"})}
                        filterMode="server"
                        onFilterModelChange={(param)=>fetchNewUsersList(param.items[0]?{column:param.items[0].field, search: param.items[0].value}:{column: "last_login_time"})}

                    /> }
                    {users && activeTab === 0 && <DataGrid disableRowSelectionOnClick autoHeight
                        sx={{
                            '& .MuiDataGrid-columnHeaders': {
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontWeight: 'bold',
                                },
                            },
                            '& .MuiDataGrid-filterForm':{
                                '.MuiDataGrid-filterFormOperatorInput': {
                                    display: 'none', 
                                }
                            },
                        }}
                        slotProps={{
                            filterPanel: {
                                filterFormProps:{
                                    operatorInputProps:{
                                        sx:{
                                            display: 'none'
                                        }
                                    }
                                }
                            }
                        }}
                        rows={users.records}
                        columns={[
                            { field: 'username', hideable: false, headerName: 'Username', width: 250},
                            { field: 'fullname', headerName: 'Full Name', width: 200},
                            { field: 'email', headerName: 'Email', width: 250},
                            { field: 'role_id', headerName: 'User Role', width: 150, filterable: false, valueGetter: (value, row) => `${row.role_id ===1 ? 'User' : 'Admin'}` },
                            { field: 'is_active', headerName: 'User Status', width: 150, filterable: false, renderCell: (params) => (
                                <Typography sx={{color: params.row.is_active? "green":"red", mt:1, p:1}}>{params.row.is_active? "Active": "Deactivated"}</Typography>
                            )},
                            { field: 'group_id', headerName: 'Group', width: 200, filterable: false, valueGetter: (value, row) => `${row.group_id ? groups&&groups.find((item)=>item.id===row.group_id)&&groups.find((item)=>item.id===row.group_id).name : 'Not Assigned'}`  },
                            { field: 'group_status', headerName: 'Group Status', width: 150, filterable: false, renderCell: (params) => (
                                <>
                                    {params.row.group_status === 0 && <Typography sx={{mt:1, p:1, color:'orange'}}  color='white.main'>To Assign</Typography>}
                                    {params.row.group_status === 1 && <Typography sx={{mt:1, p:1, color:'green'}}  color='white.main'>Approved</Typography>}
                                    {params.row.group_status === 2 && <Typography sx={{mt:1, p:1, color:'red'}}  color='white.main'>Rejected</Typography>}
                                </>
                            )},
                            { field: 'customField', headerName: 'Actions', width: 100, filterable: false, renderCell: (params) => (
                                params.row.is_active?<PopupState variant="popover">
                                    {(popupState) => (
                                    <>
                                        <MoreVert sx={{cursor: 'pointer', mt:2}} {...bindTrigger(popupState)} />
                                        <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'center', horizontal: 'right' }} >
                                            <List sx={{p: 2}}>
                                                <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleGroupEditToggle(params.row); popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                       
                                                        <img src={accessIcon} alt="Icon" style={{ marginRight: '1rem', width: '20px', height: '20px' }} />
                                                        {params.row.group_status === 0 && <Typography>Assign Access Group</Typography>}
                                                        {params.row.group_status === 2 && <Typography>Assign Access Group</Typography>}
                                                        {params.row.group_status === 1 && <Typography>Edit Access Group</Typography>}
                                                    </Box>
                                                </ListItem>
                                                {params.row.group_status === 1 && <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleGroupRevokeToggle(params.row); popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                    <img src={revokeIcon} alt="Icon" style={{ marginRight: '1rem', width: '20px', height: '20px' }} />
                                                        <Typography>Revoke Group Access</Typography>
                                                    </Box>
                                                </ListItem>}
                                                {params.row.username!==user.username&&<ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleAdminEditToggle(params.row); popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                        {params.row.role_id===1 ? <VerifiedUser sx={{marginRight: '1rem'}} /> : <Person  sx={{marginRight: '1rem'}} />}
                                                        <Typography>{params.row.role_id === 1 ? 'Provide Admin Access' : 'Revoke Admin Access'}</Typography>
                                                    </Box>
                                                </ListItem>}
                                                {params.row.is_active&&params.row.username!==user.username&&<ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleUserDeactivationToggle(params.row); popupState.close()}}>
                                                    <Box display="flex" alignItems="center">
                                                        <PersonOff sx={{marginRight: '1rem'}} />
                                                        <Typography>Deactivate User</Typography>
                                                    </Box>
                                                </ListItem>}
                                            </List>
                                        </Popover>
                                    </>
                                    )}
                                </PopupState>:
                                <PopupState variant="popover">
                                    {(popupState) => (
                                    <>
                                        <MoreVert sx={{cursor: 'pointer', mt: 2}} {...bindTrigger(popupState)} />
                                        <Popover {...bindPopover(popupState)} anchorOrigin={{ vertical: 'center', horizontal: 'right' }} >
                                            <List sx={{p: 2}}>
                                                <ListItem disableGutters sx={{cursor: "pointer"}} onClick={()=> {handleUserActivationToggle(params.row); popupState.close()}}>
                                                    {params.row.username!==user.username&&<Box display="flex" alignItems="center">
                                                        <Person sx={{marginRight: '1rem'}} />
                                                        <Typography>Activate User</Typography>
                                                    </Box>}
                                                </ListItem>
                                            </List>
                                        </Popover>
                                    </>
                                    )}
                                </PopupState>
                            )}
                        ]}
                        pagination
                        initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: appConfigs.tableAttributes.size,
                                page: 0,
                              },
                            }
                        }}
                        pageSizeOptions={appConfigs.tablePageOptions}
                        paginationMode='server'
                        sortingMode="server"
                        onSortModelChange={(param)=>fetchUsersList(param[0]?{column:param[0].field, order: param[0].sort}:{column: "last_login_time"})}
                        rowCount={users.total_elements}
                        onPageChange={(param)=>fetchUsersList({column:param[0].field, order: param[0].sort})}
                        onPaginationModelChange={(param)=>fetchUsersList({page: param.page+1, size:param.pageSize, column: "last_login_time"})}
                        filterMode="server"
                        onFilterModelChange={(param)=>fetchUsersList(param.items[0]?{column:param.items[0].field, search: param.items[0].value}:{column: "last_login_time"})}
                    /> }
                </Grid>
            </Grid>
            <Dialog fullWidth open={showAdminPop} TransitionComponent={Transition} keepMounted onClose={()=>handleAdminEditToggle()}>
                <DialogTitle>{selectedRecord&&selectedRecord.role_id===1 ? "Provide Admin Access" : "Revoke Admin Access"}</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>
                            {selectedRecord&&selectedRecord.role_id===1 ? "Are you sure you want to provide Admin access to this user ?" : "Are you sure you want to revoke Admin access to this user?"}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleAdminEditToggle()}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=>handleAdminEditSubmit()}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showGroupPop} TransitionComponent={Transition} keepMounted onClose={()=>handleGroupEditToggle()}>
                <DialogTitle>{selectedRecord&&selectedRecord.group_status===1 ? "Edit Access Group" : "Assign Access Group"}</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        { groups && groups.length>0 &&<><Typography>Are you sure you want to provide an Access group to this user ? If yes, please select a group from the below.</Typography>
                        <FormControl component="fieldset" sx={{mt:2}}>
                            <FormLabel component="legend">Please select an Access Group:</FormLabel>
                            <FormGroup>
                                {groups&&groups.map((item) => (
                                <FormControlLabel key={item.id} control={ <Checkbox checked={group === item.id} onChange={(e)=>setGroup(e.target.value)} value={item.id} /> } label={item.name} />
                                ))}
                            </FormGroup>                              
                        </FormControl></>}
                               {(!groups || groups.length === 0) && <Typography>No groups configured at present. Please create a group from Domain Group Manager.</Typography>}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleGroupEditToggle()}>Cancel</Button>
                    {groups&& groups.length>0&&<Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' disabled={!(group&&group!=="")} onClick={()=>handleGroupEditSubmit(false)}>Submit</Button>}
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showGroupRevokePop} TransitionComponent={Transition} keepMounted onClose={()=>handleGroupRevokeToggle()}>
                <DialogTitle>Revoke Access Group</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>Are you sure you want to revoke the Access group to this user ?</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>handleGroupRevokeToggle()}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=>handleGroupEditSubmit(true)}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showApprovalPop} TransitionComponent={Transition} keepMounted onClose={()=>{setShowApprovalPop(false); setSelectedRecord(null); setGroup(null)}}>
                <DialogTitle>Approve Access Group</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>Are you sure you want to assign selected Access group to {selectedRecord&&selectedRecord.username}?</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>{setShowApprovalPop(false); setSelectedRecord(null); setGroup(null)}}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=>handleApprovalSubmit(true)}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showRejectionPop} TransitionComponent={Transition} keepMounted onClose={()=>{setShowRejectionPop(false); setSelectedRecord(null); setGroup(null)}}>
                <DialogTitle>Reject Access Group</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>Are you sure you want to reject Access group assignment to {selectedRecord&&selectedRecord.username}?</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>{setShowRejectionPop(false); setSelectedRecord(null); setGroup(null)}}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=>handleRejectSubmit()}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showUserDeactivatePop} TransitionComponent={Transition} keepMounted onClose={()=>{handleUserDeactivationToggle()}}>
                <DialogTitle>Deactivate the User</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>By Deactivating the user, the user will no longer have access to the application of the data. Are you sure you want to proceed?</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>{handleUserDeactivationToggle()}}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=>handleUserDeactivationSubmit()}>Submit</Button>
                </DialogActions>
            </Dialog>
            <Dialog fullWidth open={showUserActivatePop} TransitionComponent={Transition} keepMounted onClose={()=>{handleUserActivationToggle()}}>
                <DialogTitle>Activate the User</DialogTitle>
                <DialogContent>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography>By Activating the user, the user will get access to the application and the data. Are you sure you want to proceed?</Typography>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ textTransform: 'capitalize' }} variant='outlined' color='primary' onClick={()=>{handleUserActivationToggle()}}>Cancel</Button>
                    <Button sx={{ textTransform: 'capitalize' }} variant='contained' color='primary' onClick={()=>handleUserActivationSubmit()}>Submit</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}